import React, { useState, useEffect } from 'react';
import './Footer.css';

const Footer = () => {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const formatTime = (date) => {
    return date.toLocaleTimeString('tr-TR', { 
      hour: '2-digit', 
      minute: '2-digit', 
      second: '2-digit' 
    });
  };

  return (
    <footer className="cyber-footer">
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-section">
            <div className="section-title">
              <span className="prompt">$</span> cat info.txt
            </div>
            <div className="section-content">
              <p className="footer-text">
                <span className="key">NAME:</span> Enes_Tiryaki<br/>
                <span className="key">ROLE:</span> Computer_Engineer<br/>
                <span className="key">STATUS:</span> <span className="status-active">ACTIVE</span>
              </p>
            </div>
          </div>

          <div className="footer-section">
            <div className="section-title">
              <span className="prompt">$</span> ls -la skills/
            </div>
            <div className="section-content">
              <p className="footer-text">
                drwxr-xr-x mobile_dev/<br/>
                drwxr-xr-x cyber_security/<br/>
                -rw-r--r-- learning.log
              </p>
            </div>
          </div>

          <div className="footer-section">
            <div className="section-title">
              <span className="prompt">$</span> date
            </div>
            <div className="section-content">
              <p className="footer-text">
                {formatTime(time)}<br/>
                {time.toLocaleDateString('tr-TR', { 
                  day: '2-digit', 
                  month: 'long', 
                  year: 'numeric' 
                })}
              </p>
            </div>
          </div>
        </div>

        <div className="footer-divider"></div>

        <div className="footer-bottom">
          <div className="copyright">
            <span className="bracket">{'['}</span>
            © {new Date().getFullYear()} ENES_TİRYAKİ
            <span className="bracket">{']'}</span>
            <span className="separator">|</span>
            ALL_RIGHTS_RESERVED
          </div>
          <div className="footer-links">
            <a href="mailto:tiryakienes72@gmail.com" className="footer-link">
              EMAIL
            </a>
            <span className="separator">•</span>
            <a href="https://www.linkedin.com/in/enes-tiryaki/" target="_blank" rel="noopener noreferrer" className="footer-link">
              LINKEDIN
            </a>
          </div>
        </div>

        <div className="terminal-cursor">
          <span className="cursor-text">root@localhost:~#</span>
          <span className="cursor-blink">_</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
